import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1400px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <i className="ri-error-warning-line text-6xl text-foreground-300" />
      <h1 className="mt-4 font-heading text-3xl font-black text-foreground-900">页面走丢了</h1>
      <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm leading-6 text-foreground-500">
        你访问的页面可能已被移动或删除。不妨回到首页，继续浏览最新新闻爆料。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-search-line" />
          去搜索新闻
        </Link>
      </div>
    </div>
  );
}